module.exports = __webpack_public_path__ + "static/img/product2.a3650e12.png";